<template>
  <MenuButton
    :links="links"
    :tooltip="tooltip"
  >
    <v-avatar
      color="secondary lighten-5"
      size="36"
    >
      <span class="black--text font-weight-bold">{{ initials(username) }}</span>
    </v-avatar>
  </MenuButton>
</template>

<script>
import { initials } from "@/utils/string"
import { PROFILE_DRAWER_TOP } from "@/utils/links"

export default {
  name: "UserProfileButton",
  components: {
    MenuButton: () => import("@/components/generics/general/MenuButton.vue")
  },
  props: {},
  data() {
    return {
      links: PROFILE_DRAWER_TOP,
      tooltip: this.$t("commons.user.name_singular")
    }
  },
  computed: {
    username() {
      let user = this.$store.state.app.user
      return `${user.first_name} ${user.last_name}`
    }
  },
  methods: {
    initials
  }
}
</script>
